import { axiosInstance } from "../core/http";

export const ordersApi = {
  getOrdersList: (page, search) =>
    axiosInstance.get("/panel/orders/", { params: { page, search } }),
  getOrderById: (id) => axiosInstance.get(`/panel/order/${id}/`),
  updateOrderStats: (id, payload) =>
    axiosInstance.post(`/panel/order/${id}/stats/`, payload, {
      headers: {
        "Content-Type": "application/json", // Ensure the content type is set to application/json
      },
    }),
  finaliseOrder: (id) => axiosInstance.post(`/panel/order/${id}/finalise/`),
  createOrder: (payload, userId) => {
    return axiosInstance.post(`/panel/order/create/?user_id=${userId}`, payload);
  },
  searchClients: (query) =>
    axiosInstance.get(`/panel/user/client_list/?name=${query}`),
  updateOrderTeams: (id, payload) =>
    axiosInstance.post(`/panel/order/${id}/update_teams/`, payload),
  getOrderStats: (id) => axiosInstance.post(`/panel/order/${id}/stats/`),
  updateScore: (id) => axiosInstance.post(`/panel/order/${id}/update_score/`),
  cancelOrder: (id, payload) => axiosInstance.post(`/panel/order/${id}/cancel/`, payload),
  updateCameraPosition: (id, payload) =>
    axiosInstance.post(`/panel/order/${id}/update_camera_position/`, payload),
  getOrderMatches: (id) => axiosInstance.get(`/panel/order/${id}/matches/`),
};
